import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { addParametersToUri, generateSortParameters } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../app/api/routes';

export const ACCESS_RIGHTS_RESOURCE = 'accessRights';

export default ComposedComponent =>
  reduxFetch(() => [
    {
      resource: ACCESS_RIGHTS_RESOURCE,
      method: 'get',
      request: (filters, sorting) => ({
        url: addParametersToUri(apiRoutes.accessRights(), {
          ...filters,
          ...generateSortParameters(sorting),
        }),
      }),
    },
    {
      resource: 'accessRightsPage',
      method: 'get',
      request: (page, filters, sorting) => ({
        url: addParametersToUri(apiRoutes.accessRights(), {
          page,
          ...filters,
          ...generateSortParameters(sorting),
        }),
        meta: {
          mergeWithOtherList: {
            listPath: 'values',
            valueListPath: 'values',
            resource: ACCESS_RIGHTS_RESOURCE,
            idProp: 'id',
          },
        },
      }),
    },
  ])(props => <ComposedComponent {...props} />);
